import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import FE_A from "../../Assets/img/Kyc/FE_A.png"
import BE_A from "../../Assets/img/Kyc/BE_A.jpg"

const VisitCardSkeleton = () => {
    return (
        <Box sx={{ 
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gap: "20px", // space between front and back card
            justifyItems: "center",
            // border: "1px dashed grey",
            // borderRadius: "8px",
            // padding:"10px"
        }}>
            <Typography>Front Preview</Typography>
            <Box sx={{ padding: "16px", border: "1px dashed grey", borderRadius: "8px" }}>
               <img width={"300px"} src={FE_A} />
            </Box>

            {/* Dashed Divider */}
            {/* <Box sx={{
                width: "80%",
                borderBottom: "1px dashed grey",
                margin: "10px 0"
            }} /> */}

            <Typography>Back Preview</Typography>
            <Box sx={{ padding: "10px", border: "1px dashed grey", borderRadius: "8px" }}>
                {/* <Box sx={{ pt: 0.5 }}>
                    <Skeleton width="70%" />
                    <Skeleton width="50%" />
                </Box>
                <Skeleton variant="rectangular" width={300} height={180} /> */}
                
                <img width={"300px"} src={BE_A} />
            </Box>
        </Box>
    );
};

export default VisitCardSkeleton;
